/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {SnackbarProvider} from 'notistack'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useMemo, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {ModuleModel} from '../../models'
import {getListModulesExcelService, getModulesService} from '../../services'
import {FormMasiveUploadModule} from '../Forms/FormMasiveUploadModule'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {SelectOption} from '../../../../../../models/utility.model'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {useModules} from '../../../../hooks/useModules'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import moment from 'moment'

const TableModules: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    selectedOn,
    clearTable,
    updateTable,
    setClearTable,
    setUpdateTable,
  } = useKTable()
  const {changeCurrentTabItem, currentTabItem, isAllowed} = useHoteleria()
  const {changeSearchValues, searchValues, clearSearchValues} = useKhipu()
  const {getCompanies, getClients, getSites, getCamps} = useCentralServices()
  const {getTypeModules, getStatusModule, getTypeBuildings} = useModules()

  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSites] = useState<SelectOption[]>([])
  const [camp, setCamps] = useState<SelectOption[]>([])
  const [typeModules, setTypeModules] = useState<SelectOption[]>([])
  const [statusModules, setStatusModules] = useState<SelectOption[]>([])
  // const [typeBuildings, setTypeBuildings] = useState<SelectOption[]>([])

  const getModules = async () => {
    try {
      setLoading(true)
      const {data: response} = await getModulesService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...searchValues,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    setCompany(data)
  }

  const getClientsFn = async () => {
    const data = await getClients({isCombo: true}, 1)
    setClient(data)
  }

  const getSitesFn = async () => {
    const data = await getSites({isCombo: true}, 1)
    setSites(data)
  }

  const getCampsFn = async () => {
    const data = await getCamps({isCombo: true}, 1)
    setCamps(data)
  }

  const getTypeModulesFn = async () => {
    const data = await getTypeModules()
    setTypeModules(data)
  }

  const getStatusModulesFn = async () => {
    const data = await getStatusModule()
    setStatusModules(data)
  }

  // const getTypeBuildingsFn = async () => {
  //   const data = await getTypeBuildings()
  //   setTypeBuildings(data)
  // }

  useEffect(() => {
    getCompaniesFn()
    getTypeModulesFn()
    getStatusModulesFn()
    // getTypeBuildingsFn()
    getClientsFn()
    getSitesFn()
    getCampsFn()
    return () => {
      clearSearchValues()
    }
  }, [])

  useEffect(() => {
    getModules()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    if (currentTabItem.deleted) {
      clearSelected()
      getModules()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.deleted])

  useEffect(() => {
    if (currentTabItem.updated) {
      clearSelected()
      getModules()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.updated])

  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.Id,
      idToDelete: '',
      content: {
        ...currentTabItem.content,
        detailPanel: 'form-edit-module',
      },
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<ModuleModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].Id}
            clickHandler={handleGetId}
          />
        ),
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name={'CompaniaId'}
            selecteable
            data={compani}
          />
        ),
        accessor: 'Compania_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'ClienteId'}
            selecteable
            data={client}
          />
        ),
        accessor: 'Cliente_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Site' name={'SiteId'} selecteable data={site} />
        ),
        accessor: 'Site_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name={'CampamentoId'}
            selecteable
            data={camp}
          />
        ),
        accessor: 'Campamento_descripcion',
      },
      // {
      //   Header: (props) => (
      //     <KTableHeader
      //       tableProps={props}
      //       title='Tipo de Edificación'
      //       name='TipoEdificacionId'
      //       selecteable
      //       data={typeBuildings}
      //     />
      //   ),
      //   accessor: 'TipoEdificacion',
      // },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Módulo'
            name={'Codigo'}
            searcheable
          />
        ),
        accessor: 'Codigo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Módulo'
            name='TipoModuloId'
            selecteable
            data={typeModules}
          />
        ),
        accessor: 'TipoModulo_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado de Módulo'
            name='EstadoModuloId'
            selecteable
            data={statusModules}
          />
        ),
        accessor: 'EstadoModulo_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nro de Pisos'
            name='NroPisos'
            searcheable
            number
          />
        ),
        accessor: 'NroPisos',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) =>
          isAllowed('EDITAR') ? (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleViewPanel(props)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          ) : (
            <></>
          ),
      },
    ],
    [compani, client, site, camp, typeModules, statusModules, selectedOn],
  )

  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        getModules()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        getModules()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleExport = async () => {
    try {
      const response = await getListModulesExcelService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...searchValues,
      })
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Modulos-${moment().format('DD/MM/YY HH:mm').toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {}
  }

  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='m-5'>
          <ButtonWrapper className={'sdx-white-bg'}>
            {isAllowed('EXPORTAR') && (
              <Button label='Exportar' onClick={handleExport} disabled={data.length < 1} />
            )}
          </ButtonWrapper>
          <KTable data={data} columns={columns} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

const TableModulesWrapper = () => {
  const {isAllowed} = useHoteleria()
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Módulos</Tab>
            {isAllowed('MASIVO') && <Tab className={'sdx_sub_tab_panel_option'}>Carga Masiva</Tab>}
          </TabList>
          <TabPanel>
            <TableModules />
          </TabPanel>
          {isAllowed('MASIVO') && (
            <TabPanel>
              <FormMasiveUploadModule />
            </TabPanel>
          )}
        </Tabs>
      </div>
      <SnackbarProvider />
    </KTableProvider>
  )
}

export {TableModulesWrapper}
